import { css, html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { TmBaseComponent } from '../..';
import { chevronForwardIcon } from '../../assets/icons';
import '../tm-bottom-sheet';
import '../tm-button';
import '../tm-footer';

export const tagName = 'tm-slider';
@customElement(tagName)
export class TmSlider extends TmBaseComponent {
    @property({ type: Boolean, reflect: true })
    public disabled = false;

    @property({ type: Boolean, reflect: true, attribute: 'no-sheet' })
    public noSheet = false;

    @property({ type: String })
    public header = '';

    @property({ type: String })
    public value?: string;

    @property({ type: String })
    public placeholder = 'Select';

    @property({ type: Boolean })
    public disableSubmitButton = false;

    @property({ type: Boolean })
    public showControls = false;

    @property({ type: Boolean })
    public showFdicSign = false;

    @state()
    private open = false;

    protected render() {
        return html`<button
                class="flex items-center"
                type="button"
                ?disabled=${this.disabled}
                @click=${() => {
                    if (this.noSheet) {
                        return;
                    }

                    if (!this.disabled) {
                        this.open = true;
                    }
                }}
            >
                <slot name="left"></slot>
                <div class="flex justify-end items-center">
                    <slot name="right">
                        <div
                            class=${classMap({
                                'text-[--disabled]': this.disabled,
                                'text-action': !this.disabled,
                            })}
                        >
                            ${this.value ?? this.placeholder}
                        </div>
                        <div
                            class=${classMap({
                                'action-icon w-4 ml-1 -mr-1': true,
                                'action-icon--disabled': this.disabled,
                            })}
                        >
                            ${chevronForwardIcon}
                        </div>
                    </slot>
                </div>
            </button>
            <tm-bottom-sheet
                .open=${this.open}
                horizontal
                @close=${() => {
                    this.open = false;
                    this.dispatchEvent(new Event('cancel-tm-slider', { bubbles: true }));
                }}
            >
                <p slot="header-center">${this.header}</p>
                ${this.showFdicSign
                    ? html`<tm-fdic-digital-sign
                          slot="fdic-sign"
                          container="px-4 py-2 bg-header"
                          reversed
                      ></tm-fdic-digital-sign>`
                    : nothing}
                <slot></slot>
                ${this.renderFooter()}
            </tm-bottom-sheet> `;
    }

    private handleApply() {
        this.open = false;
        this.dispatchEvent(new Event('apply-tm-slider', { bubbles: true }));
    }

    private renderFooter() {
        if (!this.showControls) {
            return nothing;
        }

        return html`<tm-footer
            class="absolute"
            .buttonConfig=${[
                {
                    text: 'Apply',
                    onClick: () => this.handleApply(),
                    disabled: this.disableSubmitButton,
                },
            ]}
        >
        </tm-footer>`;
    }

    public static get styles() {
        return [
            css`
                :host {
                    --disabled: var(--primary-30);
                }
                :host([theme='dark']) {
                    --disabled: var(--tm-color-gray-light-30);
                }
                .action-icon svg {
                    width: 100%;
                    height: auto;
                }
                .action-icon--disabled path {
                    fill: var(--disabled);
                }
                button[disabled] {
                    cursor: not-allowed;
                }
                :host(.form-row-slotted) button {
                    min-height: 40px;
                    margin: 8px 0 8px auto;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmSlider;
    }
}
